class ProcessDiagram {
  constructor(element) {
    this.el = element;
    this.isAuto = true;
    this.autoInterval = null;
    this.restartTimeout = null;
    this.animationDuration = 6000;
    this.activeIndex = parseInt(element.dataset.activeIndex);
    this.animation = element.querySelector("#petri");

    this.status = {
      current: "scene-0",
      prev: "scene-0",
    };

    this.contentItems = element.querySelectorAll(".process-text");
    this.prevButtons = element.querySelectorAll("[data-prev]");
    this.nextButtons = element.querySelectorAll("[data-next]");
    this.count = this.contentItems.length;
    this.init();
    this.startAuto();

    this.goto(this.activeIndex);
  }

  restartProgressAnimation() {
    const button = this.el.querySelector(".about-process-button.is-next");

    const animation = button
      .getAnimations({ subtree: true })
      .find(
        (animation) => animation.animationName === "about-process-button-next",
      );

    if (!animation) return;

    animation.currentTime = 0;
    animation.play();
  }

  init() {
    this.prevButtons.forEach((button) => {
      button.addEventListener("click", () => {
        this.onUserInteract();
        this.prev();
      });
    });

    this.nextButtons.forEach((button) => {
      button.addEventListener("click", () => {
        this.onUserInteract();
        this.next();
      });
    });

    this.el.style.setProperty(
      "--process-diagram-animation-duration",
      this.animationDuration + "ms",
    );

    this.goto(this.activeIndex);
  }

  startAuto() {
    this.stopAuto();
    this.el.classList.add("is-animating");
    this.autoInterval = setInterval(() => {
      this.next();
      this.restartProgressAnimation();
    }, this.animationDuration); // must line up with the animation duration in the CSS
  }

  stopAuto() {
    this.el.classList.remove("is-animating");
    clearInterval(this.autoInterval);
    clearTimeout(this.restartTimeout);
    this.autoInterval = null;
    this.restartTimeout = null;
  }

  onUserInteract() {
    this.stopAuto();
    this.restartTimeout = setTimeout(() => {
      this.startAuto();
    }, 10000);
  }

  goto(index) {
    const previousIndex = this.activeIndex;

    this.activeIndex = parseInt(index);
    this.contentItems.forEach((item, i) => {
      item.classList.toggle("is-active", this.activeIndex === i);
    });
    this.el.dataset.activeIndex = this.activeIndex;

    this.animation.classList.remove("playing-scene-0", "prev-scene-0");

    for (let i = 0; i < this.count; i++) {
      // Unfortunately the class indexes are off by one
      this.animation.classList.toggle(`playing-scene-${i + 1}`, i === index);
      this.animation.classList.toggle(
        `prev-scene-${i + 1}`,
        i === previousIndex,
      );
    }
  }

  next() {
    const index = (this.activeIndex + 1) % this.count;
    this.goto(index);
  }

  prev() {
    const index = (this.activeIndex - 1 + this.count) % this.count;
    this.goto(index);
  }
}

export default {
  processDiagrams: [],
  init() {
    this.processDiagrams = Array.from(
      document.querySelectorAll(".about-process"),
    ).map((element) => {
      return new ProcessDiagram(element);
    });
  },
  destroy() {
    console.log("Need to write a destroy function for the new timeline");
  },
};

const oldTimeline = {
  fadeInTl: null,

  status: {
    current: "scene-0",
    prev: "scene-0",
  },

  filterClasses(el, except) {
    const classesToRemove = ["0", "1", "2", "3", "4"]
      .flatMap((n) => [`playing-scene-${n}`, `prev-scene-${n}`])
      .filter((c) => !except.includes(c));

    el.classList.remove(...classesToRemove);
    el.classList.add(...except);
  },

  init() {
    if (!document.querySelector(".process-text-wrapper")) {
      return;
    }

    this.animation = document.querySelector("#petri");
    this.processBlocks = Array.from(document.querySelectorAll("[data-scene]"));

    this.status = {
      current: "scene-0",
      prev: "scene-0",
    };

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.status.prev = this.status.current;
            this.status.current = entry.target.dataset.scene;

            this.filterClasses(this.animation, [
              `playing-${this.status.current}`,
              `prev-${this.status.prev}`,
            ]);
          }
        });
      },
      {
        threshold: 0.1,
      },
    );

    this.processBlocks.forEach((processBlock) => {
      this.observer.observe(processBlock);
    });
  },

  destroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    this.animation = null;
    this.processBlocks = null;

    this.status = {
      current: "scene-0",
      prev: "scene-0",
    };
  },
};
